import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { flatten, compact, intersection, uniq, omit, flattenDeep } from 'lodash';
import { filterEmptyValues } from 'libs/utils/object';
import { CATALOG_PER_PAGE } from 'state/items/constants';
import { OptionType } from 'constants/dynamic-filters';
import { CATALOG_URL } from 'constants/routes';
import { logMessage } from 'libs/utils/window';
export const searchSuggestionToFilters = suggestion => {
  const {
    filters
  } = suggestion;
  return {
    query: filters.query,
    catalogIds: filters.catalogIds
  };
};
export const searchSuggestionToUrlParams = suggestion => {
  const {
    filters
  } = suggestion;
  const params = {
    search_text: filters.query,
    brand_id: [],
    color_id: [],
    size_id: [],
    status: [],
    catalog: filters.catalogIds,
    disposal: [],
    price_from: null,
    price_to: null
  };
  return filterEmptyValues(params);
};
export const filterMatchingSizeGroups = (sizeGroups, catalogsToMatch) => {
  const catalogsToSizeGroupIds = _ref => {
    let {
      sizeGroupIds
    } = _ref;
    return sizeGroupIds;
  };

  const catalogSizeGroupIds = flatten(catalogsToMatch.map(catalogsToSizeGroupIds));
  const matchingSizeGroupIds = intersection(catalogSizeGroupIds, sizeGroups.map(sizeGroup => sizeGroup.id));
  return compact(matchingSizeGroupIds.map(id => sizeGroups.find(it => it.id === id)));
};
export const filterMatchingSizeIds = (sizeGroups, sizeIdsToMatch) => {
  const sizeIds = uniq(flatten(sizeGroups.map(sizeGroup => sizeGroup.sizes.map(_ref2 => {
    let {
      id
    } = _ref2;
    return id;
  }))));
  return intersection(sizeIds, sizeIdsToMatch);
};
export const buildCatalogPaginationParams = pagination => {
  const page = Number(pagination.page) > 1 ? pagination.page : null;
  const perPage = pagination.perPage === CATALOG_PER_PAGE ? null : pagination.perPage;
  return {
    per_page: perPage,
    time: pagination.time,
    page
  };
};
export const buildFilterUrlParams = filters => ({
  search_text: filters.query,
  brand_ids: filters.brandIds,
  color_ids: filters.colorIds,
  size_ids: filters.sizeIds,
  material_ids: filters.materialIds,
  video_game_rating_ids: filters.videoGameRatingIds,
  status_ids: filters.statusIds,
  catalog: filters.catalogIds,
  price_from: filters.priceFrom,
  price_to: filters.priceTo,
  currency: filters.currency,
  order: filters.sortBy,
  disabled_personalization: filters.isPersonalizationDisabled ? true : null,
  popular: filters.isPopularCatalog ? true : null,
  catalog_from: filters.query ? null : filters.catalogFrom
});

const getSelectedDynamicFiltersParams = selectedDynamicFilters => {
  if (!selectedDynamicFilters) return {};
  const dynamicParams = {};
  selectedDynamicFilters.forEach(_ref3 => {
    let {
      type,
      ids
    } = _ref3;
    dynamicParams["".concat(type, "_ids")] = ids;
  });
  return dynamicParams;
};

export const buildCatalogUrlParams = _ref4 => {
  let {
    filters,
    selectedDynamicFilters,
    pagination,
    extraParams
  } = _ref4;

  const params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extraParams), buildFilterUrlParams(filters)), getSelectedDynamicFiltersParams(selectedDynamicFilters)), buildCatalogPaginationParams(pagination));

  return filterEmptyValues(params);
};
export const getCatalogInitializersParamsFromUrl = (relativeUrl, params) => {
  const CATALOG_ID_REGEX = /^\/catalog\/(\d+).*$/;
  const BRAND_ID_REGEX = /^\/brand\/(\d+).*$/;

  if (relativeUrl === CATALOG_URL) {
    // https://www.vinted.fr/catalog?color_ids[]=1&catalog[]=2050
    return params;
  }

  if (relativeUrl.match(CATALOG_ID_REGEX)) {
    // https://www.vinted.fr/catalog/5-men
    const catalogIdMatches = relativeUrl.match(CATALOG_ID_REGEX);
    const catalogId = catalogIdMatches === null || catalogIdMatches === void 0 ? void 0 : catalogIdMatches[1];
    return _objectSpread(_objectSpread({}, params), {}, {
      catalog: catalogId && [catalogId]
    });
  }

  if (relativeUrl.match(BRAND_ID_REGEX)) {
    // https://www.vinted.fr/brand/175586-garancia
    const brandIdMatches = relativeUrl.match(BRAND_ID_REGEX);
    const brandId = brandIdMatches === null || brandIdMatches === void 0 ? void 0 : brandIdMatches[1];
    return _objectSpread(_objectSpread({}, params), {}, {
      brand_ids: brandId && [brandId]
    });
  }

  logMessage('Unexpected catalog code branch in getCatalogInitializersParamsFromUrl');
  return params;
};
export const buildSubcatalogUrlParams = args => {
  const {
    filters,
    extraParams
  } = args;

  const fullParams = _objectSpread(_objectSpread({}, extraParams), buildFilterUrlParams(filters)); // Omiting params that might not be available on target catalog, these come from catalog_helper.rb
  // TODO: improve these if continuing with this feature


  const subcatalogParams = omit(fullParams, ['catalog', 'size_id', 'material_ids', 'id', 'page']);
  return filterEmptyValues(subcatalogParams);
};
export const isColorFilterVisible = catalogs => !catalogs.length || catalogs.some(_ref5 => {
  let {
    isColorAvailable
  } = _ref5;
  return isColorAvailable;
});
export const isBrandFilterVisible = catalogs => !catalogs.length || catalogs.some(_ref6 => {
  let {
    isBrandsAvailable
  } = _ref6;
  return isBrandsAvailable;
});
export const isSizeFilterVisible = catalogs => !catalogs.length || catalogs.some(_ref7 => {
  let {
    isSizesAvailable
  } = _ref7;
  return isSizesAvailable;
});
export const isVideoGameRatingFilterVisible = catalogs => catalogs.some(_ref8 => {
  let {
    isVideoGameRatingAvailable
  } = _ref8;
  return isVideoGameRatingAvailable;
});

const dynamicFilterOptions = options => options.map(option => {
  return [option, ...dynamicFilterOptions(option.options)];
});

export const flattenDynamicFilterOptions = options => flattenDeep(dynamicFilterOptions(options)).filter(filter => filter.type === OptionType.Default);
export const modifySelectedNavigationalFilters = (groups, selectedIds) => {
  const selectedGroups = [];
  const remainingGroups = [];
  groups.forEach(group => {
    const {
      id,
      description,
      items
    } = group;
    const selectedItems = [];
    const remainingItems = [];
    items.forEach(item => {
      if (selectedIds.includes(item.id)) {
        selectedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    if (selectedItems.length > 0) {
      const selectedGroup = {
        // Due to duplications of groups, we need to create new unique group ids for react keys
        id: id * -1,
        description,
        items: selectedItems
      };
      selectedGroups.push(selectedGroup);

      if (remainingItems.length > 0) {
        remainingGroups.push({
          id,
          description,
          items: remainingItems
        });
      }
    } else {
      remainingGroups.push(group);
    }
  });
  remainingGroups.sort((argA, argB) => argA.id - argB.id);
  return [...selectedGroups, ...remainingGroups];
};